import React from "react";

/**
 * A component that displays user profile information
 *
 * @param {Object} props - Component props
 * @param {Object} props.userInfo - User information from Cognito
 * @param {Function} props.onSignOut - Callback function for sign out action
 * @returns {JSX.Element} - The user profile component
 */
export default function UserProfile({ userInfo, onSignOut }) {
  // Extract user information
  const username = userInfo["cognito:username"] || "";
  const email = userInfo.email || "";
  const name = userInfo.name || "";
  const roles = userInfo["cognito:groups"] || [];

  return (
    <div className="mb-4 overflow-hidden rounded-lg px-8 pt-6 pb-8">
      <h2 className="text-center">You are signed in as:</h2>
      {/* User details */}
      <div className="my-4">
        <div className="space-y-2">
          <div className="flex border-b border-gray-200 pb-2">
            <span className="w-24 font-medium">Name:</span>
            <div className="flex items-center gap-2">
              <span className="">{name || "Not provided"}</span>
            </div>
          </div>

          <div className="flex border-b border-gray-200 pb-2">
            <span className="w-24 font-medium">Email:</span>
            <span className="">{email}</span>
          </div>

          <div className="flex border-b border-gray-200 pb-2">
            <span className="w-24 font-medium">Username:</span>
            <span className="">{username}</span>
          </div>

          {/* Roles section */}
          {roles.length > 0 && (
            <div className="flex items-center border-b border-gray-200 pb-2">
              <div className="w-24 font-medium">Roles:</div>
              <div className="flex flex-wrap gap-2">
                {roles.map((role, index) => (
                  <span key={index} className="bg-proof-blue/80 rounded-full px-3 py-1 text-sm font-medium text-white">
                    {role}
                  </span>
                ))}
              </div>
            </div>
          )}
        </div>
      </div>

      {/* Sign out button */}
      <div className="mt-8 flex items-center justify-between">
        <a className="text-proof-blue hover:text-proof-blue/80 inline-block align-baseline text-sm font-bold" href="/">
          Return Home
        </a>
        <button
          onClick={onSignOut}
          className="bg-proof-blue hover:bg-proof-blue/80 focus:shadow-outline rounded px-4 py-2 font-bold text-white focus:outline-none"
        >
          Sign Out
        </button>
      </div>
    </div>
  );
}
